import { createWebBackApi } from '../../api/webBackApi';

const webBackApi = createWebBackApi({
  timeout: 180000,
});

export const uploadLogo = async (customerId, file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await webBackApi.post(
      `/api/s3-customer-data/logo/upload?customerId=${customerId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error uploading logo for customer ${customerId}:`, error);
    throw error;
  }
};
